import { NgModule } from "@angular/core";
import { AuthImgDirective } from "./auth-img.directive";

/**
 * Carries `appAuthImg` to every module that shows a photograph.
 *
 * The directive was declared straight on AdminModule, and an Angular directive
 * belongs to exactly one module - so the staffadmin screens could not use it and
 * were left with plain `src=`, which 401s on the gated upload route. Its own
 * module lets both import it without either pulling in the other.
 */
@NgModule({
  declarations: [AuthImgDirective],
  exports: [AuthImgDirective],
})
export class AuthImgModule {}
